var app = require('../index');
var midiUtil = require('../../util/midi');
var deepCopy = require('../../util/deepCopy');

app.fn('songs.search', function(e, el) {
	var model = this.model;
	//We use deepCopy() in case validation fails, since the modifications we make here to the search object should only be applied
	//right before actually sending the search to the server
	var search = deepCopy( model.get('_session.songSearch') );
	
	//Don't include null values or empty arrays in the search - instead, just don't include those fields at all
	for (var key in search) {
		if (search[key]==null || (Array.isArray(search) && search.length==0) ) {
			delete search[key];
		}
	}

	//Check to see if any parameters have "multiple" selected and parse accordingly
	var fieldsWithMultipleOption = ['ageRange', 'voiceType', 'tempo', 'popularity'];
	
	fieldsWithMultipleOption.forEach(function(fieldName) {
		var fieldNamePlural = (fieldName === 'popularity' ? 'popularities': fieldName + 's');
		if (search[fieldName]) {
			if (search[fieldName] == 'multiple') {
				search[fieldNamePlural] = model.get('_page.' + fieldNamePlural);
				if (!search[fieldNamePlural] || !search[fieldNamePlural].length) delete search[fieldNamePlural];
			}
			else {
				//if just one is selected, then add it to the array
				search[fieldNamePlural] = [search[fieldName]];
			}
		}
		else delete search[fieldNamePlural];

		delete search[fieldName]; //only the plural version (e.g. search.ageRanges, not search.ageRange) gets sent to the server
	});

//	if (search.ageRange == 'multiple') {
//		search.ageRanges = model.get('_page.multipleAgeRanges');
//		if (!search.ageRanges || !search.ageRanges.length) delete search.ageRanges;
//	}
//	else if (search.ageRange) {
//		//if just one is selected, then add it to the array
//		search.ageRanges = [search.ageRange];
//	}
//	else delete search.ageRanges;
//
//	delete search.ageRange; //the plural version, search.ageRanges, is what gets sent to the server

	//Get values from auto-suggest fields
	if ($('#composers').length) {
		var composers = jQuery('#composers').val();
        if (composers) search.composerIds = composers;
        else delete search.composerIds; //in case the user deleted all previously entered composers
	}
	else if (search.composerIds && search.composerIds.length==0) {
		delete search.composerIds;
	}

	var lyricists = jQuery('#lyricists').val();
	if (lyricists) search.lyricistIds = lyricists;
	else delete search.lyricistIds;

	var tags = jQuery('#tags').val();
	if (tags) search.tags = tags;
	else delete search.tags; //in case the user deleted all previously entered tags

	//only one of these (decade range or year range) can be searched at the same time
	var from, to;
	if (search.decadeOrYear == 'decade') {
		delete search.fromYear;
		delete search.toYear;

		//TODO is this the desired behavior?
//		if (search.fromDecade || search.toDecade) {
//			if (search.fromDecade && !search.toDecade) {
//				search.toDecade = search.fromDecade;
//			}
//			else if (search.toDecade && !search.fromDecade) {
//				search.fromDecade = search.toDecade;
//			}
//		}
		from = search.fromDecade;
		to = search.toDecade;
	}
	else {
		delete search.fromDecade;
		delete search.toDecade;

		if (search.fromYear || search.toYear) {
			//TODO is this the desired behavior?
//			if (search.fromYear && !search.toYear) {
//				search.toYear = search.fromYear;
//			}
//			else if (search.toYear && !search.fromYear) {
//				search.fromYear = search.toYear;
//			}

			var regexp = /^\d{4}$/;
			if ((search.fromYear && !regexp.test(search.fromYear)) || (search.toYear && !regexp.test(search.toYear))) {
				alert('Please enter valid 4-digit years');
				return;
			}
		}

		from = search.fromYear;
		to = search.toYear;
	}
	if (from && to && from > to) {
		alert('The "From" decade/year cannot be greater than the "To" decade/year. Please enter a valid decade/year range.');
		return;
	}

	//the decade and year select/input boxes are bound independently so we don't need to send this to the search/songs route
    delete search.decadeOrYear;

    //if "both" is selected for comedic/dramatic, no need to include it as a search parameter at all
    if ($('input[name=isComic]:checked').val()=='both') {
        delete search.isComic;
    }

	delete search.timeSignature; //delete previous value, if any, in case the user decided to unset this parameter
	if (search.timeSignatureNumerator) {
		if (!search.timeSignatureDenominator) {
			alert('Please select both the numerator and the denominator if you would like to search by time signature');
			return;
		}
		search.timeSignature = search.timeSignatureNumerator + '/' + search.timeSignatureDenominator;
		delete search.timeSignatureNumerator;
	}
	//this is prefilled by default so we need to delete it regardless
	delete search.timeSignatureDenominator;

	if (search.originalKey) {
		if (search.originalKey.pitch && !search.originalKey.majorMinor) {
			alert('Please choose "major" or "minor" if you want to search by original key.');
			return;
		}
	}

	//Voice range

	//don't include the voice range at all if "Don't limit voice range" is selected,
	//but save it as prevLimitVoiceRange so that we can remember it the next time the voice range field is enabled
	if (!model.get('_page.limitVoiceRange') && search.voiceRange) {
		//log('saving prev', search.voiceRange)
	
		search.prevVoiceRange = search.voiceRange;
		delete search.voiceRange;
		
		//log('now ', search.prevVoiceRange)
	}

	var voiceRangeSearch = search.voiceRange;
	if (voiceRangeSearch) {
		//In case this is the old voice selector with dropdowns for older browsers,
		//midiNum should be regenerated each time based on the note and octave selection
		if (voiceRangeSearch.lowestNote) delete voiceRangeSearch.lowestNote.midiNum;
		if (voiceRangeSearch.highestNote) delete voiceRangeSearch.highestNote.midiNum;

		//TODO simplify this logic
		var isValid = true;
		if (voiceRangeSearch.lowestNote && (voiceRangeSearch.lowestNote.note || voiceRangeSearch.lowestNote.octave)) {
			if (! (voiceRangeSearch.lowestNote.note && voiceRangeSearch.lowestNote.octave) ) {
				isValid = false;
			}
		}
		else delete voiceRangeSearch.lowestNote;

		if (voiceRangeSearch.highestNote && (voiceRangeSearch.highestNote.note || voiceRangeSearch.highestNote.octave)) {
			if (! (voiceRangeSearch.highestNote.note && voiceRangeSearch.highestNote.octave) ) {
				isValid = false;
			}
		}
		else delete voiceRangeSearch.highestNote;

		//For the old voice selector with dropdowns for older browsers
		if (!isValid) {
			alert('In order to search by voice range, both the pitch and octave of the note must be entered.');
			return;
		}

		var voiceRange = voiceRangeSearch;

		//convert to MIDI note numbers
		if (voiceRange.lowestNote) voiceRange.lowestNote.midiNum = midiUtil.getMidiNoteNum(voiceRangeSearch.lowestNote.note, voiceRangeSearch.lowestNote.octave);
        if (voiceRange.highestNote) {
            voiceRange.highestNote.midiNum = midiUtil.getMidiNoteNum(voiceRangeSearch.highestNote.note, voiceRangeSearch.highestNote.octave);
            //For the old voice selector with dropdowns for older browsers
			if (voiceRange.highestNote.midiNum > 90) {
				alert("The highest note of any song in our database is F6. Did you mean to select "+voiceRangeSearch.highestNote.note+"5?");
				return;
			}
        }

		//For the old voice selector with dropdowns for older browsers
        if ((voiceRange.lowestNote && voiceRange.highestNote) && voiceRange.lowestNote.midiNum >= voiceRange.highestNote.midiNum) {
            alert('Error: Note entered for lowest note of voice range is the same or higher than the note entered for the highest note of the voice range');
            return;
        }
	}

	if (!search.showTitle) delete search.showTitle;
	if (!search.songTitle) delete search.songTitle;

	var isEmptySearch = false;
	var count = 0;
	for (var field in search) {
		//Note: decadeOrYear is selected to decade by default so it will always be present even if the user hasn't selected any search criteria yet.
        //And the others aren't real search parameters
        if (field=='decadeOrYear' || field=='_showSongDetailsOnPageLoad' || field=='prevVoiceRange') continue;
        count++;
	}
	if (count==0) {
		isEmptySearch = true;
	}
	//special case: don't allow the fact that majorMinor is set to null by default to be mistaken for
	//a user-entered search parameter
	else if (count==1 && search.originalKey && !search.originalKey.pitch && !search.originalKey.majorMinor) {
		isEmptySearch = true;
	}

	if (isEmptySearch) {
		alert('Please select at least one search condition.');
		return;
	}

	//send the JSON object to the server (via AJAX) so it can save it in the session

	//var urlParams = 'search=' + encodeURIComponent(JSON.stringify(search))
	//log('/save-song-search-to-session?' + urlParams)

	//send the JSON object to the search/songs route
	window.location = '/search/songs?search=' + encodeURIComponent(JSON.stringify(search));

	//Commenting since we're doing /save-song-search-to-session from render:search-results now
	/*
	//TODO this should probably be a POST request
	jQuery.get('/save-song-search-to-session?' + urlParams)
	.success(doRedirect)
	.error(doRedirect); //while obviously it's bad if the search doesn't save successfully we don't want it to break the search completely

	//send the JSON object to the search/songs route

	//TODO
	//WORKAROUND
	//For now, we force rendering on the server due to the issue with decade and year described in the
	//comment above the search/songs route
	function doRedirect() {
		window.location = '/search/songs?search=' + encodeURIComponent(JSON.stringify(search));
		//app.history.push('/search/songs?search=' + encodeURIComponent(JSON.stringify(search)) );
	}
	*/
});

app.fn('songs.findContrastingSongs', function(e, el) {
	var isValidContrastingSearch = false;
	var search = this.model.get('_session.songSearch');
	if ('isComic' in search) {
		search.isComic = !search.isComic;
		isValidContrastingSearch = true;
	}
	if ('tempos' in search) {
		var containsEasyBallad = (search.tempos.indexOf('Easy Ballad') != -1);
		var containsUpTempo = (search.tempos.indexOf('Up-Tempo') != -1);
		if (containsEasyBallad || containsUpTempo) {
			//if both were selected, then there's nothing to reverse to search for contrasting songs
			if (! (containsEasyBallad && containsUpTempo) ) {
				var tempoToFind = (containsEasyBallad ? 'Easy Ballad': 'Up-Tempo');
				var replaceWith = (containsEasyBallad ? 'Up-Tempo': 'Easy Ballad');
				var idx = search.tempos.indexOf(tempoToFind);
				search.tempos[idx] = replaceWith;

				isValidContrastingSearch = true;
			}
		}
	}

	//The "Find contrasting song" button shouldn't appear in this case, but just in case...
	if (!isValidContrastingSearch) {
		alert('Error generating contrasting songs search.');
		return;
	}
	window.location = '/search/songs?search=' + encodeURIComponent(JSON.stringify(search));
});